export const environment = {
  apiBaseUrl: "https://rainbowpaint.lgkdev.it",
  production: false,
  version: '1.2.0'
};